<template>
  <div>
    <app-heading
      :text="'NBN Organisation Management'"
      :heading="'main'"
    ></app-heading>
    <v-row class="mb-4">
      <v-col
        cols="12"
        md="8"
        lg="9"
        class="pt-0 pb-0"
        :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
      >
        <v-btn
          class="primary"
          @click="addOrganisation({})"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
        >Create a new Organisation</v-btn
        >
        &nbsp;
      </v-col>
    </v-row>
    <v-divider class="mt-6 mb-4"></v-divider>

    <v-row class="mb-4">
<!--      <v-col cols="12" sm="9" md="9" class="py-0">-->
<!--        <v-row>-->
<!--          <v-col cols="12" sm="3" md="2" class="py-0">-->
<!--            <v-checkbox-->
<!--              label="Completed"-->
<!--              v-model="filterCompleted"-->
<!--              class="custom-width"-->
<!--              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"-->
<!--            ></v-checkbox>-->
<!--          </v-col>-->

<!--          <v-col cols="12" sm="3" md="2" class="py-0">-->
<!--            <v-checkbox-->
<!--              label="Cancelled"-->
<!--              v-model="filterCancelled"-->
<!--              class="custom-width"-->
<!--              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"-->
<!--            ></v-checkbox>-->
<!--          </v-col>-->

<!--          <v-col cols="12" sm="3" md="2" class="py-0">-->
<!--            <v-checkbox-->
<!--              label="Rejected"-->
<!--              v-model="filterRejected"-->
<!--              class="custom-width"-->
<!--              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"-->
<!--            ></v-checkbox>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </v-col>-->

      <v-col cols="12" sm="3" :class="$vuetify.breakpoint.xs ? 'pt-0' : ''">
        <app-search @search="onGridSearch"></app-search>
      </v-col>
    </v-row>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      @cellClicked="onRowClicked"
      rowSelection="single"
    ></ag-grid-vue>
    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="nbnDataOptions.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>

    <add-organisation
      ref="addOrganisation"
      :show-add-organisation="showAddOrganisation"
      @closeQuery="closeOrganisationDialog()"
    >
    </add-organisation>

    <edit-organisation
      ref="editOrganisation"
      :show-edit-organisation="showEditOrganisation"
      :organisationRecord="organisationData"
      @closeQuery="closeOrganisationDialog()"
    ></edit-organisation>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import { formatDateTime} from "@/plugins/global-functions";
export default {
  name: "OrganisationManagement",
  components: { AgGridVue },
  data: () => ({
    showNewAppointment: false,
    showQueryAppointment:false,
    showAddOrganisation:false,
    showEditOrganisation:false,
    filterCompleted: false,
    filterCancelled: false,
    filterRejected: false,
    isEditing: false,
    viewAppointment: false,
    organisationData: {},
    statusFilter: -1,
    pageSize: 50,
    keyword: null,
    page: 1,
    paging: {
      pageNo: 1,
      pageSize: 25,
      keyword: "",
    },
    nbnDataOptions:{},
    items: [],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    gridOptions: {},
    columnDefs: [
      {
        headerName: "Id",
        field: "id",
      },
      {
        headerName: "PartyId",
        field: "partyId",
      },
      {
        headerName: "BusinessId",
        field: "businessId",
      },
      {
        headerName: "ProjectCode",
        field: "projectCode",
      },
      {
        headerName: "BusinessSize",
        field: "businessSize",
      },
      {
        headerName: "BusinessTradingName",
        field: "businessTradingName",
      },
      {
        headerName: "BusinessName",
        field: "businessName",
      },
      {
        headerName: "CreatedTime",
        field: "created",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      {
        headerName: "UpdatedTime",
        field: "updated",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      // {
      //   headerName: "Ticket ID",
      //   field: "jsonData",
      //   cellRenderer: function (data) {
      //     let parsedData = JSON.parse(data.value);
      //     let newItem = parsedData.CustomerReference;
      //     if (parsedData.CustomerReference.includes("_")) {
      //       newItem = parsedData.CustomerReference.slice(
      //         newItem.indexOf("_") + 1,
      //         parsedData.length
      //       );
      //     }
      //     return `<a href="https://vonex.kayako.com/agent/conversations/${newItem}" class="ticket-link" target="_blank">${parsedData.CustomerReference}</a>`;
      //   },
      // },
    ],
  }),
  computed: {
    filteredItems: function () {
      let vm = this;
      // let items = vm.appointments;

      // if (!vm.filterCompleted) items = items.filter((x) => x.status != 4);
      //
      // if (!vm.filterCancelled) items = items.filter((x) => x.status != 0);
      //
      // if (!vm.filterRejected) items = items.filter((x) => x.status != 1);

      return vm.items;
    },
  },
  methods:{
    addOrganisation(){
      let vm = this;
      vm.$refs.addOrganisation.showAddOrganisation = true;
    },
    editOrganisation(){
      let vm = this;
      vm.$refs.editOrganisation.showEditOrganisation = true;
    },
    closeOrganisationDialog(){
      let vm = this;
      vm.$refs.addOrganisation.showAddOrganisation = false;
      vm.showAddOrganisation = false;

      vm.$refs.editOrganisation.showEditOrganisation = false;
      vm.showEditOrganisation = false;

      vm.getOrganisationsData();
    },
    onGridSearch(keyword) {
      let vm = this;

      if (vm.statusFilter === null) vm.statusFilter = -1;

      vm.keyword = keyword;

      var search = {
        keyword: vm.keyword,
        statusFilter: parseInt(vm.statusFilter),
        pageSize: parseInt(vm.pageSize),
        pageNumber:1
      };

      clearTimeout(vm._timerId);

      vm._timerId = setTimeout(() => {
        vm.getOrganisationsAsync(search)
          .then((data) => {
            vm.items = data.data.items;
            vm.nbnDataOptions = data.data;
            vm.gridApi.sizeColumnsToFit();
          })
          .catch(() => {});
      }, 500);
    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      let vm = this;
      vm.$refs.editOrganisation.showEditOrganisation = true;
      vm.showEditOrganisation = true;
      vm.organisationData = args.data;
    },
    paginationChange(val){
      let vm = this;
      vm.paging.pageNo = val;
      vm.getOrganisationsData();
    },
    getOrganisationsData(){
      let vm=this;
      var search = {
        keyword: null,
        statusFilter: -1,
        pageSize: vm.paging.pageSize,
        pageNumber: vm.paging.pageNo
      }

      vm.getOrganisationsAsync(search)
        .then((data) => {
          vm.items = data.data.items;
          vm.nbnDataOptions = data.data;
          vm.gridApi.sizeColumnsToFit();
        })
        .catch(() => {});
    }
  },
  beforeMount() {
    let vm = this;
    vm.getOrganisationsData();
  },
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
    vm.$refs.addOrganisation.setWholesaler();
  },
}
</script>

<style scoped>

</style>
